﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs, eBundle } from "@app/helpers/dirs";

export interface IMarkdownViewerScope extends ng.IScope {
    ngModel: string;
    _html: string;

    kbClick: (obj: any) => void;
}
/**
 * Given markdown text in the ngModel, will display the html
 */
@NgComponent({
    token: Token.KbMarkdownViewer
})
export class KbMarkdownViewer extends Directive {
    constructor() {
        super();
        this.scope = {
            ngModel: "=",
            kbClick: "&",
        };

        this.restrict = "E";
        this.template = Dirs.component("kb-markdown-viewer", eBundle.app);
        this.replace = true;
        this.require = "ngModel";

        this.link = (scope: IMarkdownViewerScope, element: JQuery, atts, ngModel: ng.INgModelController) => {
            // override the onPrepareImage from the markdown library so that we can have our
            // custom image size add-on.  
            // to control size of images, append =heightxwidth to the end of the url
            // some markdown implementations have a space before the equals sign, but
            // that doesn't seem to be possible here because markdownDeep won't recognize it
            // as an image at all
            MarkdownDeep.Markdown.prototype.OnPrepareImage = (tag: HTMLElement) => {
                let re = /=(\w+)x(\w+)$/;
                let src: string = tag.attributes["src"];
                let parts = src.match(re);
                if (parts && parts[0]) {
                    tag.attributes["src"] = src.substr(0, src.length - parts[0].length);
                    tag.attributes["width"] = parts[1];
                    tag.attributes["height"] = parts[2];
                }
            };

            ngModel.$render = () => { // called when the binding has been changed by the consumer
                // Create an instance of Markdown
                let md = new MarkdownDeep.Markdown();
                md.NewWindowForExternalLinks = true;
                let v = ngModel.$viewValue;
                scope._html = v? md.Transform(v): null;
            };

            let html = $(element).find(".kb-markdown-viewer");

            let getEvent = (e: MouseEvent) => {


                let event = {
                    target: e.target,
                    currentTarget: e.currentTarget
                }
                return event;
            };

            let onMouseup = (e: PointerEvent) => {
                scope.kbClick({ $event: e });
                e.preventDefault();
                e.stopPropagation();
            };

            element[0].addEventListener("click", onMouseup);

            scope.$on("$destroy", () => {
                element[0].removeEventListener("click", onMouseup);
            });

        };
    }
}
